import React from 'react';
import { ChevronDownIcon, MessageCircleIcon } from 'lucide-react';
export type BrandAlert = {
  brand: string;
  category: 'Action needed' | 'Conversation';
  preview: string;
  updatedAt: string;
};
export const brandAlerts: BrandAlert[] = [{
  brand: 'Eddy',
  category: 'Action needed',
  preview: 'Approval needed: Summer recovery plan',
  updatedAt: '12m'
}, {
  brand: 'Eddy',
  category: 'Conversation',
  preview: 'Question about approved channels',
  updatedAt: '43m'
}, {
  brand: '1 People',
  category: 'Conversation',
  preview: 'Request to review floor pricing',
  updatedAt: '1h'
}, {
  brand: 'Nature Baby',
  category: 'Action needed',
  preview: 'Inventory submission needs confirmation',
  updatedAt: '3h'
}];
export function AdminMessagesNavItem({
  active,
  expanded,
  onOpenMessages,
  onToggleExpanded,
  onSelectBrand,
  variant = 'desktop'
}: {
  active: boolean;
  expanded: boolean;
  onOpenMessages: () => void;
  onToggleExpanded: () => void;
  onSelectBrand: (brand: string) => void;
  variant?: 'desktop' | 'mobile';
}) {
  const brandsNeedingAttention = Array.from(new Set(brandAlerts.map(alert => alert.brand)));
  return <div data-id="element-21" data-mp="29y70k7per78n">
      <div className={`flex items-center gap-1 rounded-xl pr-1 transition-colors ${active ? 'bg-forest text-cream shadow-sm' : 'text-ink/65 hover:bg-forest/5 hover:text-forest'} ${variant === 'mobile' && active ? 'bg-[#BB5E40]' : ''}`} data-id="element-22" data-mp="29yfcnxdpi8is">
        <button type="button" onClick={onOpenMessages} className={`flex min-h-11 flex-1 items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium focus:outline-none focus:ring-2 focus:ring-forest/15 ${variant === 'mobile' ? 'min-h-11' : ''}`} data-id="element-23" data-mp="1w7a6sdjqwk00">
          <MessageCircleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-24" data-mp="1i8akvdnmaj7j" />
          <span className="flex items-center gap-2" data-id="element-25" data-mp="3gksr8j6i2ipk">
            Messages
            <span className={`h-2 w-2 shrink-0 rounded-full ${active ? 'bg-cream' : 'bg-[#C0392B]'}`} aria-label={`${brandAlerts.length} brand messages need attention`} data-id="element-26" data-mp="3cjz5nwgj5fzu" />
          </span>
        </button>
        <button type="button" onClick={onToggleExpanded} aria-expanded={expanded} aria-label="Show brands needing attention" className={`rounded-lg p-1.5 focus:outline-none focus:ring-2 focus:ring-forest/15 ${active ? 'text-cream/80 hover:bg-cream/15' : 'text-ink/45 hover:bg-forest/8'}`} data-id="element-27" data-mp="1epuz0con5xau">
          <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-28" data-mp="1xmd0hltalbka" />
        </button>
      </div>

      {expanded && <div className="mt-2 overflow-hidden rounded-xl border border-ink/10 bg-cream/70" data-id="element-29" data-mp="1om822162tni9">
          <div className="flex items-center justify-between gap-2 border-b border-ink/10 px-3 py-2" data-id="element-30" data-mp="88rbvjmq9fxy">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-ink/50" data-id="element-31" data-mp="d83yq4dlmn0j">Needs attention</p>
            <span className="rounded-full bg-[#C0392B]/10 px-2 py-0.5 text-[10px] font-semibold text-[#C0392B]" data-id="element-32" data-mp="4pskk1fafy44">
              {brandsNeedingAttention.length} brands
            </span>
          </div>
          <ul className="max-h-52 overflow-y-auto p-1" data-id="element-33" data-mp="eozxini41qqp">
            {brandAlerts.map(alert => <li key={`${alert.brand}-${alert.preview}`} data-id="element-34" data-mp="9pdiq9mmw2fs">
                <button type="button" onClick={() => onSelectBrand(alert.brand)} className="w-full rounded-lg px-2.5 py-2 text-left transition-colors hover:bg-paper" data-id="element-35" data-mp="9nu4eokjg1gn">
                  <div className="flex items-center justify-between gap-2" data-id="element-36" data-mp="3rvjh28xeasza">
                    <span className="flex min-w-0 items-center gap-1.5" data-id="element-37" data-mp="3n4tet4k9n68t">
                      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${alert.category === 'Action needed' ? 'bg-[#C0392B]' : 'bg-[#C9A04E]'}`} aria-hidden="true" data-id="element-38" data-mp="3n2gni0smbjj3" />
                      <span className="truncate text-xs font-semibold text-ink" data-id="element-39" data-mp="1xp0rp7wbr7cb">{alert.brand}</span>
                    </span>
                    <span className="shrink-0 text-[10px] text-ink/45" data-id="element-40" data-mp="22odgvzao4qi2">{alert.updatedAt}</span>
                  </div>
                  <p className="mt-1 truncate pl-3 text-[11px] text-ink/55" data-id="element-41" data-mp="26nvyom770lgo">{alert.preview}</p>
                </button>
              </li>)}
          </ul>
        </div>}
    </div>;
}